import { defineStore } from "pinia";
import { IAuthForm, IUser } from "@/types";
import { ref } from "vue";
import { apiGetLogin, apiGetProfile } from "@/api/auth-api";
import axios from "axios";
import { useCookies } from "@vueuse/integrations/useCookies";
import { useRouter } from "vue-router";
import { RouteNames } from "@/router/routes";

export const useAuthStore = defineStore("auth", () => {
  const user = ref<IUser>({
    id: "",
    first_name: "",
    last_name: "",
    surname: "",
    blocked_admin: false,
    position: "",
    super_admin: false,
    email: "",
    phone: "",
    roles: [],
  });
  const { set, remove } = useCookies();
  const router = useRouter();
  const isLoaded = ref(false);

  const resetUser = (): IUser => ({
    id: "",
    first_name: "",
    last_name: "",
    surname: "",
    position: "",
    blocked_admin: false,
    super_admin: false,
    email: "",
    phone: "",
    roles: [],
  });

  const login = async (authForm: IAuthForm) => {
    try {
      const { data } = await apiGetLogin(authForm);
      set("token", data.data.access_token);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return Promise.reject(error.response?.data || error);
      }
    }
  };

  const fetchUserProfile = async () => {
    try {
      const { data } = await apiGetProfile();
      user.value = data.data;

      if (
        (user.value.blocked_admin || user.value.roles.length === 0) &&
        !user.value.super_admin
      ) {
        await router.replace({ name: RouteNames.BLOCKED_VIEW });
      }
      isLoaded.value = true;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return Promise.reject(error.response?.data.message || error.message);
      }
    }
  };

  const logout = async () => {
    user.value = resetUser();
    remove("token", { path: "/" });
    await router.replace({ name: RouteNames.LOGIN_VIEW });
  };

  return {
    user,
    isLoaded,
    login,
    logout,
    fetchUserProfile,
  };
});
